import { buildApiUrl } from '../../services/apiConfig';

const API_BASE_URL = buildApiUrl('SQL');

export const fetchDomains = async () => {
    const response = await fetch(`${API_BASE_URL}/api/domains`);
    const data = await response.json();
    return data.domains || [];
};

export const fetchUseCases = async (domainId) => {
    const response = await fetch(`${API_BASE_URL}/api/domains/${domainId}/usecases`);
    const data = await response.json();
    return (data.usecases || []).map(item => ({
        id: item.id,
        name: item.name,
        domain: item.domain_name,
        description: item.description,
        createdBy: item.created_by
    }));
};

export const fetchTabs = async (useCaseId, userId) => {
    const response = await fetch(`${API_BASE_URL}/api/usecases/${useCaseId}/tabs?user_id=${userId}`);
    const data = await response.json();
    return (data.tabs || []).map(tab => ({
        id: tab.id,
        name: tab.name,
        description: tab.description,
        use_case_id: tab.use_case_id,
        user_id: userId
    }));
};

export const fetchAgents = async (tabId, userId) => {
    const response = await fetch(`${API_BASE_URL}/api/tabs/${tabId}/agents?user_id=${userId}`);
    const data = await response.json();
    return (data.agents || []).map(agent => ({
        id: agent.id,
        name: agent.name,
        tool_id: agent.tool_id,
        tool_prompt: agent.tool_prompt || '',
        visual_prompt: agent.visual_prompt || '',
        widget_id: agent.widget_id || '',
        user_id: agent.user_id || '00001',
        tool_name: agent.tool_name,
        status: agent.visual_prompt ? 'active' : 'inactive',
        tab_id: agent.tab_id
    }));
};

export const fetchTools = async () => {
    const response = await fetch(`${API_BASE_URL}/api/tools`);
    const data = await response.json();
    return data.tools || [];
};

export const fetchToolConfig = async (toolId) => {
    const response = await fetch(`${API_BASE_URL}/api/tools/${toolId}/config`);
    const data = await response.json();
    if (data.error) return null;
    const config = data.config;
    if (!config || (!config.dropdown && !config.input)) return null;
    return config;
};

export const fetchMaxDomainId = async () => {
    const response = await fetch(`${API_BASE_URL}/api/domains/max-id`);
    const data = await response.json();
    return data.max_id || '00000';
};

export const fetchMaxUseCaseId = async () => {
    const response = await fetch(`${API_BASE_URL}/api/usecases/max-id`);
    const data = await response.json();
    return data.max_id || '00000';
};

export const fetchMaxTabId = async () => {
    const response = await fetch(`${API_BASE_URL}/api/tabs/max-id`);
    const data = await response.json();
    return data.max_id || '00000';
};

export const fetchMaxAgentId = async () => {
    const response = await fetch(`${API_BASE_URL}/api/agents/max-id`);
    const data = await response.json();
    const maxId = data.max_id;
    if (!maxId || typeof maxId !== 'string' || !/^\d+$/.test(maxId)) return '00000';
    return maxId;
};

export const addDomain = async (id, name) => {
    const response = await fetch(`${API_BASE_URL}/table-backend/domains`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ID: id, name })
    });
    return response.ok;
};

export const createUseCase = async (useCase) => {
    const response = await fetch(`${API_BASE_URL}/table-backend/use_cases`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(useCase)
    });
    return response.ok;
};

export const runUpdate = async (query) => {
    const response = await fetch(`${API_BASE_URL}/run-update-backend`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ query })
    });
    return response.ok;
};

export const createTab = async (tab) => {
    const response = await fetch(`${API_BASE_URL}/table-backend/tabs`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(tab)
    });
    return response.ok;
};

export const createAgent = async (agent) => {
    const response = await fetch(`${API_BASE_URL}/table-backend/widgets`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(agent)
    });
    return response.ok;
};
